/** @format */

export const utilitySaveToLocalStorage = (
  ref: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Object | Array<any>,
): void => localStorage.setItem(ref, JSON.stringify(data));
